import { useMemo } from 'react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import usePaginatedQuery from '@/hooks/usePaginatedQuery'

export type QueryVariables = {
  filter: GraphQL.QueryStayFilter
  sort: GraphQL.QueryStaySort
}

export default function usePaginatedStays(variables: QueryVariables) {
  const vars = useMemo(() => {
    return { ...variables, withGuests: true, withSpace: true }
  }, [variables])

  const { items: fragmentItems, ...rest } = usePaginatedQuery(
    AdminAPI.stay.QUERY,
    vars,
    {
      document: AdminAPI.stay.CHANGED,
      typename: 'Stay',
      variables: { withSpace: true }
    }
  )

  const items = useMemo(() => {
    return fragmentItems?.map(item =>
      getFragment(SharedAPI.stay.STAY_FRAGMENT, item)
    )
  }, [fragmentItems])

  return {
    items,
    ...rest
  }
}
